<template>

  <div class="stats__card events">
    <h3 class="cardTitle">Events</h3>
    <div v-if="events" class="list">
      <p class="event" v-for="event in events">{{event.userDescription}} <span
          class="right">{{displayTime(event.time)}}</span></p>
    </div>
    <div v-if="!events" class="loader__container">
      <Loader ></Loader>
    </div>

  </div>

</template>
<script>
  import Loader from "./Loader"
  export default {
    name: "Events",
    components: {Loader},
    data() {
      return {
        events: false
      }
    },
    methods: {
      displayTime(time) {
       // return this.$moment.unix(time).format("MM/D/YYYY, hh:mm")
        return this.$moment.unix(time).fromNow()
      }
    },
    mounted() {
      fetch(this.$store.getters.api + "/api/v1/admin/events", {
        method: "get",
        headers: {
          "authorization": this.$store.getters.token
        }
      }).then(async res => {
        let jsonRes = await res.json()
        console.log(jsonRes)
        this.events = jsonRes.events.sort((a, b) => {
          return b.time - a.time
        })
      })
    },
  }
</script>
